module.exports = __webpack_public_path__ + "528f7ae0c916b26d0d2dca7d27db0d62.MP3";